import $ from 'jquery';

    function setSwitchToggle(obj) {
        var wrapper = $(obj).closest("[data-switcher-wrapper='true']")
        var parent = $(obj).closest('.switcher');
        if ($(obj).is(':checked')) {
            parent.addClass('checked');
            $(wrapper).find("[data-switcher-value='true']").removeClass('hide');
            $(wrapper).find("[data-switcher-value='false']").addClass('hide');
        } else {
            parent.removeClass('checked');
            $(wrapper).find("[data-switcher-value='true']").addClass('hide');
            $(wrapper).find("[data-switcher-value='false']").removeClass('hide');
        }
    }

export default function () {
    // switcher
    $(".switch-toggle", this).each(function () {
        const checkbox = $(this).find("input[type=checkbox]");
        setSwitchToggle(checkbox);
        checkbox.on('change', function () {
            setSwitchToggle(this);
        });
    });
};
